<template>
    <Dialog :visible="visible" @on-close="onClose" class="camera-dialog" :title="title">
        <template #content>
            <div class="column justify-center full-height no-wrap">
                <Camera @on-capture-image="onCaptureImage" />
            </div>
        </template>
    </Dialog>
</template>

<script setup lang="ts">
import Camera from "@/shared/camera/camera.vue";
import Dialog from "@/shared/components/dialog/dialog.vue";

defineProps<{ visible: boolean; title: string }>();
const emits = defineEmits<{ onClose: []; onCaptureImage: [blob: Blob] }>();

const onClose = () => {
    emits("onClose");
};

const onCaptureImage = (blob: Blob) => {
    emits("onCaptureImage", blob);
};
</script>

<style lang="scss">
.camera-dialog {
    .dialog-card {
        flex-wrap: nowrap;
        max-width: 800px !important;
        width: 800px !important;
    }
    .video-box {
        margin-bottom: $spacing-l;
    }
}
</style>
